module.exports = __webpack_public_path__ + "media/images/story_commercial_video_image/vertical-b34d154a630aa2e661e6346157f013fb.png";